export default __webpack_public_path__ + "static/media/WeD1.56dc4166.png";